import Vue from 'vue/dist/vue.min.js';
import store from './store';

const homeHero = () => {

    const component = document.querySelector('.home-hero');

    let heroConstructor = () => {
        Vue.component('home-hero', {
            data: function() {
                return {
                   selectedId: null
                }
            },
            mounted() {
                this.$on('select-section', (id) => {
                    this.selectedId = id;
                });
            }
        });

        Vue.component('hero-section', {
            props: ['selectedId'],
            data: function() {
                return {
                   isActive: false,
                   isHovered: false,
                   id: null
                }
            },
            watch: {
                selectedId: function() {
                    this.isActive = this.selectedId == this.id ? true : false;
                },
                isHovered: function() {
                    if (this.isHovered || this.isActive) {
                        this.playVideo();
                    } else {
                        this.pauseVideo();
                    }
                },
                isActive: function() {
                    if (this.isActive) {
                        this.playVideo();
                    } else {
                        this.pauseVideo();
                    }
                }
            },
            methods: {
              toggleExpand() {
                  this.$parent.$emit('select-section', this.isActive ? null : this.id);
                // this.isActive = !this.isActive;
              },
              mouseover() {
                // console.log("moused over");
                this.isHovered = true;
              },
              mouseleave() {
                // console.log("mouse leave");
                this.isHovered = false;
              },
              playVideo() {
                this.$refs.video.play();
              },
              pauseVideo() {
                this.$refs.video.pause();
              },
              init() {
                  this.id = Array.from(document.querySelectorAll('.home-hero__area')).indexOf(this.$el);
              },
            },
            mounted() {
                this.init();
            }
        });

        new Vue({
            el: `.home-hero`,
        }).$mount(`.home-hero`, true);
    }

    if (component) {
        heroConstructor();
    }

}

export default homeHero;
